import React, { useState } from 'react'
import GloblePopup from '../../common/GloblePopup'
import { useTranslation } from 'react-i18next';

export default function IpDetailsPopup({isOpen,handleClose,betsData}) {
const { t, i18n } = useTranslation();
  return (
    <GloblePopup
      isOpen={isOpen}
      onClose={handleClose}
      title={t("IP Detail")}
      className="ip-modal"
      cancelText="Close">
        <div className="ip-detail">
            <div className="ip-detail-row">
                <div>{t('IP')}</div> <div>{betsData?.ip_address}</div>
            </div>
            <div className="ip-detail-row">
                <div>{t('City')}</div> <div>{betsData?.geolocation?.city}</div>
            </div>
            <div className="ip-detail-row">
                <div>{t('Country')}</div> <div>{betsData?.geolocation?.country}</div>
            </div>
        </div>
    </GloblePopup>
  )
}
